var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
import { Box } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
export var MyButton = styled(IconButton)(function (props) { return ({
    '&&': {
        color: props.customColor,
        background: 'none',
        cursor: 'auto',
        '&:hover': {
            background: 'none',
            backgroundColor: 'none',
            cursor: 'auto'
        }
    }
}); });
export var ProgressWrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .MuiDataGrid-cell {\n    line-height: 0px;\n  }\n"], ["\n  .MuiDataGrid-cell {\n    line-height: 0px;\n  }\n"])));
export var BoxWrapper = styled(Box)({
    '&&': {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 0,
        margin: 0
    }
});
export var Status = styled('h5')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  letter-spacing: 1px;\n  font-weight: 600;\n  margin: 0;\n"], ["\n  text-align: center;\n  letter-spacing: 1px;\n  font-weight: 600;\n  margin: 0;\n"])));
export var CustomCell = styled('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
export var MultilineText = styled('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  line-height: 18px;\n  white-space: normal;\n"], ["\n  line-height: 18px;\n  white-space: normal;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=OversightColumns.Styles.js.map